import React from 'react';

import { createUseContext } from '../../../utils/create-use-context';

import { ThreadApi } from './thread';
import { AskBlueJApi } from './ask-bluej-api';
import { SourceApi } from './sources';
import { ProjectApi } from './project';
import { WorkflowsApi } from '../../workflows/api';
import { InteractionsApi } from '../../interactions/api';

export type AskBlueJApiContextValue = {
  api: AskBlueJApi,
  threadApi: ThreadApi,
  sourceApi: SourceApi,
  projectApi: ProjectApi,
  workflowsApi: WorkflowsApi,
  interactionsApi: InteractionsApi
} | null

const AskBluejApiContext = React.createContext<AskBlueJApiContextValue>(null);

AskBluejApiContext.displayName = 'AskBluejApiContext';

export const useAskBluejApiContext = createUseContext(AskBluejApiContext);

export const AskBlueJApiContextProvider = AskBluejApiContext.Provider;
